module.exports = __webpack_public_path__ + "static/media/alignMiddle.08c197b9.svg";